// @flow

import { localStorage } from './storage';

/**
 * Return lang param for external url like Uphold
 * @param lang
 * @returns {string}
 */
export const getExtUrlLang = (lang = false) => {
  if (!lang) return "en";

  switch (lang) {
    case "ZH":
      return "en";
    default:
      return lang.toLowerCase();
  }
};

export const getLang = () => {
  const fallback = "en";

  if (localStorage.hbcLang) {
    return localStorage.hbcLang.toLowerCase();
  }

  return fallback;
};



// WEBPACK FOOTER //
// ./src/utils/language.js